interface INetworkIcon {
  color?: string;
}

const NetworkIcon: React.FC<INetworkIcon> = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <mask
        id="mask0_1138_37300"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#FAF9FA" />
      </mask>
      <g mask="url(#mask0_1138_37300)">
        <path
          d="M24 44C21.2667 44 18.6833 43.475 16.25 42.425C13.8167 41.375 11.6917 39.9417 9.875 38.125C8.05833 36.3083 6.625 34.1833 5.575 31.75C4.525 29.3167 4 26.7333 4 24C4 21.2333 4.525 18.6417 5.575 16.225C6.625 13.8083 8.05833 11.6917 9.875 9.875C11.6917 8.05833 13.8167 6.625 16.25 5.575C18.6833 4.525 21.2667 4 24 4C26.7667 4 29.3583 4.525 31.775 5.575C34.1917 6.625 36.3083 8.05833 38.125 9.875C39.9417 11.6917 41.375 13.8083 42.425 16.225C43.475 18.6417 44 21.2333 44 24C44 26.7333 43.475 29.3167 42.425 31.75C41.375 34.1833 39.9417 36.3083 38.125 38.125C36.3083 39.9417 34.1917 41.375 31.775 42.425C29.3583 43.475 26.7667 44 24 44ZM24 39.9C24.8667 38.7 25.6167 37.45 26.25 36.15C26.8833 34.85 27.4 33.4667 27.8 32H20.2C20.6 33.4667 21.1167 34.85 21.75 36.15C22.3833 37.45 23.1333 38.7 24 39.9ZM18.8 39.1C18.2 38 17.675 36.8583 17.225 35.675C16.775 34.4917 16.4 33.2667 16.1 32H10.2C11.1667 33.6667 12.375 35.1167 13.825 36.35C15.275 37.5833 16.9333 38.5 18.8 39.1ZM29.2 39.1C31.0667 38.5 32.725 37.5833 34.175 36.35C35.625 35.1167 36.8333 33.6667 37.8 32H31.9C31.6 33.2667 31.225 34.4917 30.775 35.675C30.325 36.8583 29.8 38 29.2 39.1ZM8.5 28H15.3C15.2 27.3333 15.125 26.675 15.075 26.025C15.025 25.375 15 24.7 15 24C15 23.3 15.025 22.625 15.075 21.975C15.125 21.325 15.2 20.6667 15.3 20H8.5C8.33333 20.6667 8.20833 21.325 8.125 21.975C8.04167 22.625 8 23.3 8 24C8 24.7 8.04167 25.375 8.125 26.025C8.20833 26.675 8.33333 27.3333 8.5 28ZM19.3 28H28.7C28.8 27.3333 28.875 26.675 28.925 26.025C28.975 25.375 29 24.7 29 24C29 23.3 28.975 22.625 28.925 21.975C28.875 21.325 28.8 20.6667 28.7 20H19.3C19.2 20.6667 19.125 21.325 19.075 21.975C19.025 22.625 19 23.3 19 24C19 24.7 19.025 25.375 19.075 26.025C19.125 26.675 19.2 27.3333 19.3 28ZM32.7 28H39.5C39.6667 27.3333 39.7917 26.675 39.875 26.025C39.9583 25.375 40 24.7 40 24C40 23.3 39.9583 22.625 39.875 21.975C39.7917 21.325 39.6667 20.6667 39.5 20H32.7C32.8 20.6667 32.875 21.325 32.925 21.975C32.975 22.625 33 23.3 33 24C33 24.7 32.975 25.375 32.925 26.025C32.875 26.675 32.8 27.3333 32.7 28ZM31.9 16H37.8C36.8333 14.3333 35.625 12.8833 34.175 11.65C32.725 10.4167 31.0667 9.5 29.2 8.9C29.8 10 30.325 11.1417 30.775 12.325C31.225 13.5083 31.6 14.7333 31.9 16ZM20.2 16H27.8C27.4 14.5333 26.8833 13.15 26.25 11.85C25.6167 10.55 24.8667 9.3 24 8.1C23.1333 9.3 22.3833 10.55 21.75 11.85C21.1167 13.15 20.6 14.5333 20.2 16ZM10.2 16H16.1C16.4 14.7333 16.775 13.5083 17.225 12.325C17.675 11.1417 18.2 10 18.8 8.9C16.9333 9.5 15.275 10.4167 13.825 11.65C12.375 12.8833 11.1667 14.3333 10.2 16Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

NetworkIcon.defaultProps = {
  color: "transparent",
};

export default NetworkIcon;
